import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-10-20-10-12',
  standalone: true,
  imports: [],
  templateUrl: './cp-10-20-10-12.component.html',
  styleUrl: './cp-10-20-10-12.component.scss'
})
export class Cp10201012Component {

}
